<template>
  <div>
    <v-toolbar color="pink" dark>
      <v-btn icon small flat :to="{ name: 'championship-list' }" v-if="!!championship.id">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-icon>gavel</v-icon>
      <v-toolbar-title>Championship Result {{ championship && championship.name ? " - " + championship.name :
        "" }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!!results.length" @click="declareResults">Declare Results</v-btn>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs12 md6 lg6>
              <v-list subheader>
                <v-subheader>
                  <div>Participated Teams</div>
                </v-subheader>
                <draggable v-model="teams" group="teams" style="min-height: 10px">
                  <template v-for="item in teams">
                    <v-card :key="item.id" class="mt-2">
                      <v-list-tile avatar>
                        <v-list-tile-avatar>
                          <v-icon>group</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.club.name"></v-list-tile-title>
                          <v-list-tile-sub-title>
                            <strong>Coach:</strong>
                            {{ item.coach }} |
                            <strong>Manager:</strong>
                            {{ item.manager }}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-card>
                  </template>
                </draggable>
                <v-card v-if="!teams.length">
                  <v-card-text>No teams remaining</v-card-text>
                </v-card>
              </v-list>
            </v-flex>
            <v-flex xs12 md6 lg6>
              <v-list subheader>
                <v-subheader>
                  Final Team Positions
                  <div>(drag and drop here from the participated team list)</div>
                </v-subheader>
                <v-card :key="item.id" class="mt-2" v-for="(item, index) in existing">
                  <v-list-tile avatar>
                    <v-list-tile-avatar color="pink">
                      <span class="white--text headline small-header">{{ getordinal(index + 1) }}</span>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.club.name"></v-list-tile-title>
                      <v-list-tile-sub-title>
                        <strong>Coach:</strong>
                        {{ item.coach }} |
                        <strong>Manager:</strong>
                        {{ item.manager }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-card>
                <draggable v-model="results" group="teams" style="min-height: 10px">
                  <template v-for="(item, index) in results">
                    <v-card :key="item.id" class="mt-2">
                      <v-list-tile avatar>
                        <v-list-tile-avatar color="pink">
                          <span class="white--text headline small-header">{{ getordinal(existing.length + index + 1) }}</span>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="item.club.name"></v-list-tile-title>
                          <v-list-tile-sub-title>
                            <strong>Coach:</strong>
                            {{ item.coach }} |
                            <strong>Manager:</strong>
                            {{ item.manager }}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-card>
                  </template>
                </draggable>
                <v-card v-if="!results.length">
                  <v-card-text>
                    {{ existing.length > 0 ? "You can add additional teams but cannot remove any existing ones." : "No teams added" }}
                  </v-card-text>
                </v-card>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="ui.showFeedback" :color="ui.isError ? 'error' : 'info'" :timeout="5000">
      <span>{{ ui.feedback }}</span>
      <v-btn dark flat @click="ui.showFeedback = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import _ from "underscore";

export default {
  data: function () {
    return {
      teams: [],
      results: [],
      existing: [],
      championship: {},
      ui: {
        feedback: "",
        showFeedback: false,
        isError: false,
        loading: false,
        showConfirm: false
      }
    };
  },
  components: {
    draggable
  },
  methods: {
    reload: async function (id) {
      var me = this;
      me.championship = await this.$api("championships")
        .get({ id: id });

      let teams = await this.$api("teams")
        .get({ pageSize: -1, championshipId: id });


      let positions = await this.$api("ChampionshipResults/" + this.championship.id).get();
      me.existing = positions.map(x => teams.items.find(t => t.id == x.teamId)).filter(x => x);
      me.teams = teams.items.filter(x => positions.every(p => p.teamId !== x.id));
    },
    declareResults: function () {
      var me=this;
      var positions = _.map(this.results, function (e, i) {
        return { teamId: e.id, position: me.existing.length + i + 1 };
      });

      var me = this;
      this.$api("ChampionshipResults/" + this.championship.id)
        .put(positions)
        .then(function () {
          me.$router.push({ name: "championship-list" });
        })
        .catch(function (xhr) {
          me.ui.isError = true;
          me.ui.showFeedback = true;
          me.ui.feedback =
            xhr.responseJSON && xhr.responseJSON.feedback
              ? xhr.responseJSON.feedback
              : "An error occured while processing your request";
        });
    },
    getordinal: function (i) {
      var j = i % 10,
        k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st";
      }
      if (j == 2 && k != 12) {
        return i + "nd";
      }
      if (j == 3 && k != 13) {
        return i + "rd";
      }
      return i + "th";
    }
  },
  mounted: function () {
    var id = this.$route.params.id;
    this.reload(id);
  }
};
</script>

<style scoped>
.v-avatar span.headline.small-header {
  font-size: 0.9em !important;
}
</style>